
import Vue from "vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import LitterRegistrationRequest from "@/components/Portal/MyRequest/LitterRegistrationRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

import { LitterRegistration } from "@/constants";

export default Vue.extend({
  name: "MyLitterRegistrationRequest",
  components: {
    MyRequestLayout,
    LitterRegistrationRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
      parentDnaVerifiedWarning: LitterRegistration.MissingDNA_Parents,    
      geneticTestingLink: LitterRegistration.GeneticTesting_Link,
      artificialInseminationLink: LitterRegistration.ArtificialInsemination_Link,
      registrarEmailLink: LitterRegistration.RegistrarEmail_Link,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getLitterRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData | null) {
      var req = {
        paymentInfo,
        personId: this.userInfo.personId,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitLitterCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
      console.log("cancelling request");
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
